module.exports = __webpack_public_path__ + "static/img/04.59708eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/loyaltyvenue/tutorial/04.svg
// module id = hrE0
// module chunks = 13